import React from "react"
import { Box, Heading, Text } from "@chakra-ui/react"

export default function ErrorView({ errorObject }) {
  console.log(">>> ErrorView", errorObject)

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bg="Gray.100"
      p={8}
    >
      <Box maxW="lg">
        <Heading mb={4}>Something is horribly wrong!</Heading>
        <Text mb={4}>
          If this issue persists, please inspect the console for more details.
        </Text>
        <Box bg="white" p={4} borderRadius="lg" boxShadow="lg">
          <Heading size="md" mb={2}>
            Error Details
          </Heading>
          <pre>{errorObject}</pre>
        </Box>
      </Box>
    </Box>
  )
}
